export interface BreadcrumbItem {
  label: string
  to?: string
  icon?: string
  /** This part is the current workspace: the bar renders it as the workspace switcher. */
  workspace?: boolean
}

export type ConsoleColor = 'good' | 'cyan' | 'warn' | 'bad' | 'muted' | 'accent'

export interface SubbarStatus {
  text: string
  color?: ConsoleColor
}

/** Shared breadcrumb trail rendered in the console sub-bar. */
export function useBreadcrumbs() {
  return useState<BreadcrumbItem[]>('breadcrumbs', () => [])
}

/**
 * Set the trail for a page inside a workspace: <workspace switcher> / ...tail.
 * `tail` is a getter so names that load late (an email's subject) fill in. The workspace
 * is the one in the top bar unless the page names another through `alias`.
 */
export function useWorkspaceCrumbs(tail: () => BreadcrumbItem[] = () => [], alias?: () => string | undefined) {
  const breadcrumbs = useBreadcrumbs()
  const organizationsStore = useOrganizationsStore()
  const route = useRoute()
  watchEffect(() => {
    // Read the path so this runs again after each navigation: the chrome middleware
    // clears the trail first, and a page kept alive across tabs would otherwise lose it.
    void route.fullPath
    const a = alias?.() || organizationsStore.selectedOrgAlias
    const workspace: BreadcrumbItem[] = a
      ? [{ label: organizationsStore.map[a]?.name || a, to: `/app/workspaces/${a}`, workspace: true }]
      : []
    breadcrumbs.value = [...workspace, ...tail()]
  })
}

/** Contextual right-aligned status (dot + mono text) shown in the sub-bar. */
export function useSubbarStatus() {
  return useState<SubbarStatus | null>('subbarStatus', () => null)
}
